import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router';

import { BottomNavigation } from '~widgets/navigation';

import { MEDIA_QUERY_MIN_WIDTH } from '~shared/lib/responsive';
import { Header } from '~shared/ui/header/header';
import { ScreenHeader } from '~shared/ui/screen';

export const PagesLayout = () => {
  const isUpLd = useMediaQuery({ query: MEDIA_QUERY_MIN_WIDTH.lg });

  return (
    <div className={`flex min-h-full min-w-[1024px] flex-col bg-[#f6f7f8]`}>
      {isUpLd ? <Header /> : <ScreenHeader singleLogoAlign="left" />}
      <Outlet />
      {!isUpLd && <BottomNavigation />}
    </div>
  );
};
